import React, { Component } from 'react';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Dialog, {
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
} from 'material-ui/Dialog';

import * as userActions from '../user.actions';
import { getUserById } from '../user.selectors';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
});
class RemoveUserDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      submitSuccess: false,
      actionStatus: null,
    };
  }
  componentDidMount = () => {
    const { getUsers } = this.props;
    getUsers();
  };

  handleCancel = () => {
    this.props.onRequestClose();
    this.setState({
      submitted: false,
      submitSuccess: false,
      actionStatus: null,
    });
  };
  handleRemove = () => {
    const { deleteUser, user } = this.props;
    deleteUser(user._id).then(action => {
      const message = (action && action.response && action.response.entities && action.response.entities.user 
                      && action.response.entities.user[Object.keys(action.response.entities.user)[0]] 
                      && action.response.entities.user[Object.keys(action.response.entities.user)[0]].message) || null
      if (action && action.response && action.response.status === 'ok') {
        this.setState({
          submitted: true,
          submitSuccess: true,
          actionStatus: message,
        });
      } else {
        this.setState({
          submitted: true,
          submitSuccess: false,
        });
      }
    });
  };

  renderRequest() {
    const { user } = this.props;
    if (!user) return null;
    return (
      <div>
        <DialogContent>
          <DialogContentText>
            Tahdotko varmasti poistaa käyttäjän {user.firstName} {user.lastName}?
            Toimintoa ei voi peruuttaa.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel}>Peruuta</Button>
          <Button onClick={this.handleRemove} color="primary">
            Poista
          </Button>
        </DialogActions>
      </div>
    );
  }

  renderSuccess() {
    return (
      <div>
        <DialogContent>
          {this.state.actionStatus && this.state.actionStatus === 'deleted'
            ? <DialogContentText>Käyttäjän poistaminen onnistui.</DialogContentText> 
            : this.state.actionStatus && this.state.actionStatus === 'disabled'
              ? <DialogContentText>Käyttäjä deaktivoitu. Käyttäjää ei voida kokonaan poistaa, koska käyttäjä on linkitetty olemassa oleviin raportteihin.</DialogContentText> 
              : <DialogContentText>Käyttäjän on jo deaktivoitu. Muutoksia käyttäjän tietoihin ei tehty.</DialogContentText> 
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Takaisin
          </Button>
        </DialogActions>
      </div>
    );
  }
  renderFailure() {
    return (
      <div>
        <DialogTitle>Poisto ei onnistu</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Käyttäjän poistaminen palvelusta ei onnistunut. Tarkista
            verkkoyhteytesi ja yritä myöhemmin uudelleen.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel}>Takaisin</Button>
        </DialogActions>
      </div>
    );
  }
  render() {
    const { open } = this.props;
    const { submitted, submitSuccess } = this.state;
    return (
      <Dialog onRequestClose={this.handleCancel} open={open}>
        {!submitted
          ? this.renderRequest()
          : submitSuccess ? this.renderSuccess() : this.renderFailure()}
      </Dialog>
    );
  }
}
const mapStateToProps = (state, { match }) => {
  const { params: { id } } = match;
  const user = getUserById(state, id);
  return {
    user,
  };
};

export default withRouter(
  connect(mapStateToProps, Object.assign({}, userActions))(
    withStyles(styles)(RemoveUserDialog)
  )
);



// WEBPACK FOOTER //
// ./src/modules/user/components/RemoveUserDialog.js